const baseURLs = {
  local: "http://localhost:3000/api",
  web: "https://officeapi.kaaryaalaya.com/api",
};

const environment = process.env.NODE_ENV === "production" ? "web" : "local";

export const getURL = () => baseURLs[environment];

export const getImageURL = (url) => `${getURL()}${url}`;

export default {
  getURL,
  getImageURL,
};
